import { createFileRoute } from '@tanstack/react-router';

import { getMarketingCampaignQueryOptions } from '@/_pages/marketing-campaigns/api-service';
import Loading from '@/_pages/marketing-campaigns/profile/loading';

export const Route = createFileRoute('/_private/marketing-campaigns/$id')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getMarketingCampaignQueryOptions(opts.params.id)),
  pendingComponent: Loading,
});
